export default {
	// baseURL: 'https://eduapi.yjwledu.cn/',
	// fileurl: 'https://eduapi.yjwledu.cn',
	baseURL: 'https://localhost:44356/',
	fileurl: 'https://localhost:44356',
	// baseURL: 'http://192.168.66.118:8000/',
	// fileurl: 'http://192.168.66.118:8000',
	productID: 'webPlatform',
	canvasText: '北京育见未来', //北京育见未来
	logo: true, //显示-育见
	//------------------ 系统名称------------------
	sysName:'四川城市职业学院省级虚拟仿真实训基地申报平台',
	version: 'v1.00',
}
